export let keyword = [
  {
    id: 1,
    key: "All",
  },
  {
    id: 2,
    key: "How-To HC",
  },
  {
    id: 3,
    key: "Market Insight",
  },
  {
    id: 4,
    key: "Our Games",
  },
  {
    id: 5,
    key: "MondayOFF Life",
  },
];

export let option = [
  {
    value: "All",
    label: "All",
  },
  {
    value: "How-To HC",
    label: "How-To HC",
  },
  {
    value: "Market Insight",
    label: "Market Insight",
  },
  {
    value: "Our Games",
    label: "Our Games",
  },
  {
    value: "MondayOFF Life",
    label: "MondayOFF Life",
  },
];
